module.exports = __webpack_public_path__ + "static/img/u122.12f4b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/u122.png
// module id = Uc+b
// module chunks = 1